import { useState } from 'react';
import { Heading } from '@simplywallst/ui-core/next';
import type { Brokerage } from '@/features/portfolio/components/PortfolioLinking/hooks/useBrokerages';
import { PopularBrokerage } from '@/features/portfolio/components/PortfolioLinking/components/PopularBrokerage';
import { CreateLinkedPortfolio } from '@/features/portfolio/components/PortfolioLinking';

export const NewLinkedPortfolio = () => {
  const [brokerage, setBrokerage] = useState<Brokerage | undefined>(undefined);

  return (
    <>
      <div
        className="grid gap-x1_5 px-x2 sm:px-x3"
        data-cy-id="portfolio-linking"
      >
        <Heading as="h2">Sync your broker</Heading>
        <CreateLinkedPortfolio
          brokerage={brokerage}
          setBrokerage={setBrokerage}
        />
      </div>
      <PopularBrokerage onSelect={setBrokerage} />
    </>
  );
};
